<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default {
    data() {
        return {
            quotes: [],
            Autoplay: Autoplay, Pagination: Pagination, Navigation: Navigation,
            pagination: {
                clickable: true,
                el: '.swiper-pagination',
                renderBullet: function (index, className) {
                    return '<span class=' + className + '>' + (index + 1) + '</span>';
                },
            },
        };
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    mounted() {
        var vm = this;

        vm.quotes = [
            vm.$t('slider.quotes.q1'),
            vm.$t('slider.quotes.q2'),
            vm.$t('slider.quotes.q3')
        ];
    },
}

</script>

<template>
    <div class="p-lg-5 p-4 auth-one-bg h-100">
        <div class="bg-overlay"></div>
        <div class="position-relative h-100 d-flex flex-column">
            <div class="mb-4">
                <router-link to="/" class="d-block">
                    <img src="@/assets/images/logo-light.png" alt="" height="40">
                </router-link>
            </div>
            <div class="mt-auto">
                <div class="mb-3">
                    <i class="ri-double-quotes-l display-4 text-white"></i>
                </div>

                <div id="qoutescarouselIndicators" class="carousel slide" data-bs-ride="carousel">
                    <Swiper class=" text-center text-white-50 pb-5"
                        :autoplay="{ delay: 3000, disableOnInteraction: false }" :loop="true"
                        :modules="[Autoplay, Navigation, Pagination]"
                        :pagination="{ clickable: true, el: '.swiper-pagination' }">
                        <swiper-slide v-for="(n, index) in quotes" :key="index">
                            <div>
                                <p class="text-white fs-15 fst-italic">{{ n }}</p>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination"></div>
                    </Swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.auth-one-bg {
    background-image: url("~@/assets/images/login.jpeg");
    .bg-overlay{
        background: linear-gradient(to right, darken($primary, 6%), $primary);
        opacity: 0.9;
    }
}

.auth-bg-cover {
    /* background: #f97316; */
    background: linear-gradient(-45deg,#0f172a 50%,#f97316)
}
</style>